export default {
    NEW: 'new',
    HOT: 'hot',
    SHORT: 'short',
    NETWORK: 'network',
    DUELS : 'duels'
}
